var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_11901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3902 26.1898C52.3902 21.0079 50.8536 15.9424 47.9748 11.6338C45.0959 7.32525 41.004 3.96713 36.2166 1.98411C31.4291 0.00109816 26.1612 -0.517749 21.0789 0.493184C15.9966 1.50412 11.3282 3.99942 7.66405 7.66356C3.99991 11.3277 1.5046 15.9961 0.493672 21.0784C-0.517261 26.1607 0.00158644 31.4286 1.9846 36.2161C3.96762 41.0035 7.32574 45.0954 11.6343 47.9743C15.9429 50.8532 21.0084 52.3898 26.1902 52.3898H26.6502V31.9998H21.0002V25.4398H26.6202V20.6098C26.6202 15.0098 30.0402 11.9598 35.0302 11.9598C36.7005 11.9503 38.37 12.0371 40.0302 12.2198V18.0698H36.6702C33.9602 18.0698 33.4302 19.3598 33.4302 21.2498V25.4298H39.9202L39.0702 31.9998H33.4302V51.3698C38.9023 49.8058 43.7163 46.5025 47.1443 41.9596C50.5723 37.4166 52.4278 31.8809 52.4302 26.1898",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_11901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.39,
    height: 52.39,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f0d1037f8e311ed06d21a3b7a3ccdf47.svg";
export { ForwardRef as ReactComponent };